module.exports = __webpack_public_path__ + "img/faq_2_img_6.d5876dc4.jpg";